import { NgModule } from '@angular/core';
import { DbmTimePickerComponent } from '@app/shared/components/basic-components/dbm-time-picker/dbm-time-picker.component';
import { FormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
    imports: [
        FormsModule, NgxMaterialTimepickerModule
    ],
    declarations: [DbmTimePickerComponent],
    entryComponents: [DbmTimePickerComponent],
    exports: [DbmTimePickerComponent]
})
export class DbmTimePickerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-time-picker/dbm-time-picker.module.ts